<template>
    <section v-if="noticeItem.actions.supplier?.proposal.create || noticeItem.actions.supplier.proposal.edit">
        <template v-if="hasRestrictions">
            <b-button v-if="noticeItem.actions.supplier.proposal.create" :id="'popover-fl223-' + noticeItem.id" class="btn-card-action btn-card-action-green text-uppercase my-0" target="_blank"> Подать предложение</b-button>
            <b-button v-if="noticeItem.actions.supplier.proposal.edit" :id="'popover-fl223-' + noticeItem.id" class="btn-card-action btn-card-action-orange text-uppercase my-0" target="_blank"> Изменить предложение</b-button>
            <b-popover :target="'popover-fl223-' + noticeItem.id" triggers="hover">
                <p v-if="noticeItem.restrictions.money.status" class="fs-12 my-1 py-1">
                    Необходимо для блокировки <span class="fw-600 text-nowrap">{{ $formatPrice(noticeItem.restrictions.money.fee_amount) }}</span> руб. <br />Для подачи предложения не хватает
                    <span class="text-danger fw-600 text-nowrap">{{ $formatPrice(noticeItem.restrictions.money.not_enough) }}</span> руб.<br />
                    <router-link :to="{ name: 'CabinetAccounting' }" class="system_link-style">Пополнить лицевой счет</router-link>
                    .
                </p>
                <p v-if="noticeItem.restrictions.smp.status" class="fs-12 my-1 py-1">Подача предложения невозможна, так как Ваша организация не является СМП.</p>
            </b-popover>
        </template>
        <template v-else>
            <b-button v-if="noticeItem.actions.supplier.proposal.create" :to="{ name: 'Fl223PurchaseNewProposal', params: { id: noticeItem.id } }" class="btn-card-action btn-card-action-green text-uppercase my-0" target="_blank"> Подать предложение</b-button>
            <b-button v-if="noticeItem.actions.supplier.proposal.edit" :to="{ name: 'Fl223PurchaseNewProposal', params: { id: noticeItem.id } }" class="btn-card-action btn-card-action-orange text-uppercase my-0" target="_blank"> Изменить предложение</b-button>
        </template>
    </section>
</template>

<script>
export default {
    name: 'fl223-new-proposal-button',
    props: {
        noticeItem: {
            type: Object,
            required: true
        }
    },
    computed: {
        hasRestrictions() {
            return this.noticeItem.restrictions.money.status || this.noticeItem.restrictions.smp.status;
        }
    }
};
</script>
